export default __webpack_public_path__ + "static/media/Indeed-logo.0ea91936.svg";